
    import * as React from 'react';

    const Trunkshow12 = ({ color = 'currentcolor', height = '12px', width = '12px', ...rest }) => {
      const svgStyle: React.CSSProperties = {...{"position":"absolute","top":"0","right":"0","bottom":"0","left":"0","width":"100%","height":"100%"}, fill: color};

      return (
        <div style={{ ...{"position":"relative"}, height, width }} { ...rest }>
          <svg viewBox="0 0 12 12" style={svgStyle}><path d="M3 8.53L.47 6 3 3.47 5.53 6 3 8.53zM4.47 6L3 4.53 1.53 6 3 7.47 4.47 6zM9 8.53L6.47 6 9 3.47 11.53 6 9 8.53zM10.47 6L9 4.53 7.53 6 9 7.47 10.47 6zM6 5.53L3.47 3 6 .47 8.53 3 6 5.53zM7.47 3L6 1.53 4.53 3 6 4.47 7.47 3zM6 11.53L3.47 9 6 6.47 8.53 9 6 11.53zm0-1.06L7.47 9 6 7.53 4.53 9 6 10.47z" /></svg>
        </div>
      );
    };

    Trunkshow12.displayName = 'Trunkshow12';

    export default Trunkshow12;
  